import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactTable from 'Common/ReactTableWrapper';

import { GridContextMenu } from 'Components/app/contextmenu/ContextMenuManager';

export class ImportSettingsTable extends Component {
  static propTypes = {
    data: PropTypes.array.isRequired,
    cogOptions: PropTypes.array.isRequired,
    loading: PropTypes.bool,
    closeSchoolYearClosedDate: PropTypes.object,
  };

  static defaultProps = {
    loading: false,
  };

  columns = [
    {
      Header: 'File Name',
      id: 'FileName',
      accessor: 'FileName',
    },
    {
      width: 50,
      sortable: false,
      Cell: (gridProps) => {
        return GridContextMenu({
          gridProps,
          options: this.props.cogOptions,
        });
      },
    },
  ];

  render() {
    const { data, loading, reactTableRef } = this.props;

    return (
      <ReactTable
        loading={loading}
        reactTableRef={reactTableRef}
        data={data}
        columns={this.columns}
        menu={'hasCogs'}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/importstudents/components/ImportSettingsTable.js